import gql from 'graphql-tag';
import React, { useState } from 'react';
import { Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { useLocation } from 'react-router';
import emailSentIcon from '../../images/email-sent.svg';

const SignUpEmail = ({ client }) => {
  const location = useLocation();
  const signedUpUserId = location && location.user && location.user.id;
  const signedUpFirstName =
    location && location.user && location.user.firstName;
  const signedUpLastName =
    location && location.user && location.user.lastName;
  const signedUpEmail = location && location.user && location.user.email;
  const signedUpMobile = location && location.user && location.user.mobile;

  const [first, setFirst] = useState(signedUpFirstName);
  const [last, setLast] = useState(signedUpLastName);
  const [email, setEmail] = useState(signedUpEmail);
  const [subject, setSubject] = useState();
  const [msg, setMsg] = useState();
  const [isSent, setIsSent] = useState();

  const triggerFirst = e => {
    setFirst(e.target.value);
  };

  const triggerLast = e => {
    setLast(e.target.value);
  };
  const triggerEmail = e => {
    setEmail(e.target.value);
  };

  const triggerSubject = e => {
    setSubject(e.target.value);
  };

  const triggerMsg = e => {
    setMsg(e.target.value);
  };

  const toggleEmailSent = () => {
    setIsSent(!isSent);
  };

  const SEND_EMAIL = gql`
    mutation sendEmailFromNewUser(
      $emailMessageArgs: EmailMessageAttributes!
    ) {
      sendEmailFromNewUser(emailMessageArgs: $emailMessageArgs) {
        message {
          userId
          subject
        }
      }
    }
  `;
  const handleSendEmail = () => {
    // e.preventDefault();
    client
      .mutate({
        mutation: SEND_EMAIL,
        variables: {
          emailMessageArgs: {
            userId: signedUpUserId,
            name: first + ' ' + last,
            email: email,
            subject: subject,
            mobile: signedUpMobile,
            message: msg
          }
        }
      })
      .then(res => {
        if (res.data.sendEmailFromNewUser.message) {
          toggleEmailSent();
          console.log('Email submit successful!');
        } else console.log('Email submit error!');
      });
  };

  const ableToSubmit = first && last && email && subject && msg;
  const isMobile = window.innerWidth < 768;

  return (
    <Fragment>
      {isSent ? (
        <div
          className="signup-form-container"
          style={{ width: isMobile ? '400px' : '800px' }}>
          <img src={emailSentIcon} />
        </div>
      ) : (
        <div className="signup-form-container">
          <div className="form-title">Email</div>
          <div className="input-field">
            <div className="floating-label">First name</div>
            <input
              className="input-container"
              onChange={triggerFirst}
              value={first}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Last name</div>
            <input
              className="input-container"
              onChange={triggerLast}
              value={last}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Email</div>
            <input
              className="input-container"
              onChange={triggerEmail}
              value={email}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Subject</div>
            <input
              className="input-container"
              onChange={triggerSubject}
              value={subject}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Message</div>
            <textarea
              className="input-container-msg"
              onChange={triggerMsg}
              value={msg}></textarea>
          </div>
          <button
            className="signup-button"
            style={{ background: ableToSubmit ? '#128dff' : '#87caef' }}
            onClick={() => {
              ableToSubmit && handleSendEmail();
            }}>
            Submit
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default withApollo(SignUpEmail);



// WEBPACK FOOTER //
// ./src/components/NewSignUp/SignUpEmail.js